import type { FilterDefinition } from "../config/structured-search-schema";

export interface ValueSuggestionItem {
  value: string;
  count?: number;
  prompt_name?: string;
  /** Human-readable label shown instead of the raw value (e.g. hydrated id). */
  label?: string;
}

export interface PlainTextSearchSuggestionItem {
  type: "plain_text_search";
  value: string;
  label: string;
}

export type FieldSuggestionItem = FilterDefinition;

export interface OperatorSuggestionItem {
  operator: string;
  display: string;
}

export type SuggestionItem =
  | FieldSuggestionItem
  | OperatorSuggestionItem
  | ValueSuggestionItem
  | PlainTextSearchSuggestionItem;

export enum SuggestionStepEnum {
  FIELD = "field",
  KEY = "key",
  OPERATOR = "operator",
  VALUE = "value",
  IDLE = "idle",
}
